import React from "react";
import PropTypes from "prop-types";
import SkuflixChromecastIcon from "core/icons/skuflix/SkuflixChromecastIcon";
import { useCast } from "core/components/CastProvider";
import PlayerFooterButton from "core/components/PlayerFooterButton";
import { useTranslation } from "react-i18next";
import analytics from "core/utils/analytics";

function CastButton({ hlsUrl, content, liveSeekBar }) {
  const { t } = useTranslation("core");

  const { currentContentId, startCast, isSupported, requestSession } =
    useCast();

  if (!isSupported) {
    return null;
  }

  const sameContent = content.id && currentContentId === content.id;

  if (!sameContent && !hlsUrl) {
    return null;
  }

  const handleClick = () => {
    analytics.event({
      category: "User",
      action: "Start cast",
    });
    startCast({
      hlsUrl,
      contentId: content.id,
      title: content.title,
      subtitle: content.rightholder.name,
      preview: content.preview,
      startAt: liveSeekBar?.startAtLimited,
      offset: liveSeekBar?.offset,
      live: !!liveSeekBar,
    });
  };

  const handleShowCastMenu = () => {
    requestSession();
  };

  return (
    <>
      {sameContent && (
        <PlayerFooterButton
          title={t("castButton.showCastMenu")}
          onClick={handleShowCastMenu}
        >
          <SkuflixChromecastIcon />
        </PlayerFooterButton>
      )}

      {hlsUrl && (
        <PlayerFooterButton title={t("castButton.cast")} onClick={handleClick}>
          <SkuflixChromecastIcon />
        </PlayerFooterButton>
      )}
    </>
  );
}

CastButton.propTypes = {
  hlsUrl: PropTypes.string,
  content: PropTypes.object,
  live: PropTypes.bool,
  liveSeekBar: PropTypes.object,
};

export default CastButton;
